export default function () {
  return [

    { key: 'userId', label: "users", type: 'user', selectProps: { clearable: true, multiple: true } }
    , { key: 'email' },
    { key: 'provider', type: 'smtpProvider', selectProps: { clearable: true, multiple: false } },
    { key: 'orgId', type: 'org', selectProps: { clearable: true, multiple: false } }
  ]
}
